import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=f259a000&scoped=true"
import script from "./myOrder.vue?vue&type=script&lang=js"
export * from "./myOrder.vue?vue&type=script&lang=js"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=f259a000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259a000",
  null
  
)

export default component.exports